import {
    SET_APP_START,
    LOADING,
    AUTH_FORM,
    REGISTRATION_FORM,
    RECOVERY_PASSWORD_FORM,
    CHECK_EMAIL_FORM,
    BOOKING,
    FILTERS,
    EST,
    SET_USER_BAR,
    SET_USER,
    SET_SUBSCRIPTIONS,
    SET_SCHEDULE,
    SET_SCHEDULE_ACTIVE,
    SET_MY_RESERVES,
    SET_MOBILE_MENU,
    SET_CHOICE_ADDRESS_FROM
} from "./types";

import {
    AUTH_FORM_INITIAL,
    BOOKING_INITIAL,
    CHECK_EMAIL_FORM_INITIAL,
    FILTERS_INITIAL,
    RECOVERY_PASSWORD_FORM_INITIAL,
    REGISTRATION_FORM_INITIAL,
    USER_INITIAL,
    SCHEDULE_INITIAL,
    MY_RESERVES_INITIAL,
    CHOICE_ADDRESS_FORM_INITIAL
} from './initialStateConstants';

const initialState = {
    app_start: false,
    loading: false,
    auth_form: AUTH_FORM_INITIAL,
    registration_form: REGISTRATION_FORM_INITIAL,
    recovery_password_form: RECOVERY_PASSWORD_FORM_INITIAL,
    check_email_form: CHECK_EMAIL_FORM_INITIAL,
    booking: BOOKING_INITIAL,
    filters: FILTERS_INITIAL,
    est: {
        slug: '',
        id: ''
    },
    user_bar: false,
    user: USER_INITIAL,
    subscriptions: [],
    schedule: SCHEDULE_INITIAL,
    schedule_active: false,
    my_reserves: MY_RESERVES_INITIAL,
    mobile_menu: false,
    choice_address_form: CHOICE_ADDRESS_FORM_INITIAL

};

const reducer = (state = initialState, action) => {
    switch (action.type) {
        case SET_APP_START: return { ...state, app_start: action.data };
        case LOADING: return { ...state, loading: action.data };
        case AUTH_FORM: return { ...state, auth_form: action.data };
        case REGISTRATION_FORM: return { ...state, registration_form: action.data };
        case RECOVERY_PASSWORD_FORM: return { ...state, recovery_password_form: action.data };
        case CHECK_EMAIL_FORM: return { ...state, check_email_form: action.data };
        case BOOKING: return { ...state, booking: action.data };
        case FILTERS: return { ...state, filters: action.data };
        case EST: return { ...state, est: action.data };
        case SET_USER_BAR: return { ...state, user_bar: action.data };
        case SET_USER: return { ...state, user: action.data };
        case SET_SUBSCRIPTIONS: return { ...state, subscriptions: action.data };
        case SET_SCHEDULE: return { ...state, schedule: action.data };
        case SET_SCHEDULE_ACTIVE: return { ...state, schedule_active: action.data };
        case SET_MY_RESERVES: return { ...state, my_reserves: action.data };
        case SET_MOBILE_MENU: return { ...state, mobile_menu: action.data };
        case SET_CHOICE_ADDRESS_FROM: return { ...state, choice_address_form: action.data };
        default: return state;
    }
};

export default reducer;